import styled from 'styled-components';

export const AreaFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0.4rem;
  background: ${({ theme }) => theme.grayLight};
`;

export const AreaReason = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

export const AreaButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 0.4rem;

  & .MuiButtonBase-root {
    margin-left: 0px;
    padding: 8px 25px !important;
  }
`;
